import jsPDF from "jspdf";

export const PHONE_NUMBER = "+91 9167249612";
export const ADDRESS = "4/34 Tardeo AC Market, Mumbai 400034";

// Pre-filled greeting opens in the visitor's WhatsApp so the chat starts
// with a friendly "what do you need help with?" message they can send in one tap.
const WHATSAPP_GREETING = `Hi WillSeva, I'd like some help with my will. Please assist me with:

1. Get my will vetted and reviewed by Senior Lawyers
2. Request a callback from your team
3. General query / something else

Thank you.`;

const WHATSAPP_NUMBER = "919167249612";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_GREETING)}`;

// Helper for context-specific WhatsApp links (e.g. NRI Desk, specific plan)
export function whatsappUrl(message) {
  const text = (message && message.trim()) || WHATSAPP_GREETING;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
}

export const DISCLAIMER_TEXT =
  "This document is generated based on information provided by the user and is intended to assist in creating a structured Will under applicable Indian laws. Proper execution, including signing in the presence of two attesting witnesses, is essential for validity. Users with complex family structures, business interests, disputed assets, foreign assets or tax considerations are encouraged to seek professional legal advice.";

// jsPDF's built-in fonts (times/helvetica) only support Latin-1/WinAnsi.
// Map common Unicode characters the LLM emits (₹, em-dashes, smart quotes,
// bullets, ellipsis, non-breaking space) to ASCII equivalents so text renders
// correctly in the PDF.
function toLatin1Safe(str) {
  if (!str) return "";
  const map = {
    "\u20B9": "Rs.", // ₹ rupee sign
    "\u2013": "-",   // – en dash
    "\u2014": "-",   // — em dash
    "\u2015": "-",   // ― horizontal bar
    "\u2018": "'",   // ‘
    "\u2019": "'",   // ’
    "\u201A": "'",   // ‚
    "\u201B": "'",   // ‛
    "\u201C": '"',   // “
    "\u201D": '"',   // ”
    "\u201E": '"',   // „
    "\u2026": "...", // …
    "\u2022": "*",   // •
    "\u2023": "*",   // ‣
    "\u25E6": "o",   // ◦
    "\u00A0": " ",   // non-breaking space
    "\u200B": "",    // zero-width space
    "\u200C": "",    // zero-width non-joiner
    "\u200D": "",    // zero-width joiner
    "\uFEFF": "",    // BOM
    "\u2122": "(TM)",
    "\u00A9": "(c)",
    "\u00AE": "(R)",
  };
  let out = str.replace(/[\u20B9\u2013\u2014\u2015\u2018\u2019\u201A\u201B\u201C\u201D\u201E\u2026\u2022\u2023\u25E6\u00A0\u200B\u200C\u200D\uFEFF\u2122\u00A9\u00AE]/g, (c) => map[c] ?? c);
  // Strip any other characters outside Latin-1 range to avoid silent jsPDF failures
  out = out.replace(/[^\x00-\xFF]/g, "?");
  return out;
}

export function downloadWillPdf(willText, filename = "WillSeva-Will.pdf", title = "LAST WILL AND TESTAMENT") {
  try {
    const safeWill = toLatin1Safe(willText);
    const safeDisclaimer = toLatin1Safe(DISCLAIMER_TEXT);
    const safeTitle = toLatin1Safe(title);

    const doc = new jsPDF({ unit: "pt", format: "a4" });
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginX = 56;
    const marginTop = 72;
    const marginBottom = 72;
    const contentWidth = pageWidth - marginX * 2;

    // Header
    doc.setFont("times", "bold");
    doc.setFontSize(18);
    doc.setTextColor(10, 17, 40);
    doc.text("WillSeva", marginX, 48);

    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(120, 120, 120);
    doc.text("Your Family. Your Legacy. Protected.", marginX, 62);

    // Title
    doc.setFont("times", "bold");
    doc.setFontSize(16);
    doc.setTextColor(10, 17, 40);
    doc.text(safeTitle, pageWidth / 2, marginTop, { align: "center" });

    // Body
    doc.setFont("times", "normal");
    doc.setFontSize(11);
    doc.setTextColor(20, 20, 20);

    const lines = doc.splitTextToSize(safeWill || "", contentWidth);
    let y = marginTop + 28;
    const lineHeight = 15;

    lines.forEach((line) => {
      if (y + lineHeight > pageHeight - marginBottom) {
        doc.addPage();
        y = marginTop;
      }
      doc.text(line, marginX, y);
      y += lineHeight;
    });

    // Disclaimer on last page (add new page if too close to bottom)
    if (y + 120 > pageHeight - marginBottom) {
      doc.addPage();
      y = marginTop;
    } else {
      y += 24;
    }
    doc.setDrawColor(197, 160, 89);
    doc.setLineWidth(0.8);
    doc.line(marginX, y, marginX + 40, y);
    y += 18;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(9);
    doc.setTextColor(10, 17, 40);
    doc.text("DISCLAIMER", marginX, y);
    y += 12;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.setTextColor(80, 80, 80);
    const dLines = doc.splitTextToSize(safeDisclaimer, contentWidth);
    dLines.forEach((line) => {
      if (y + 11 > pageHeight - marginBottom) {
        doc.addPage();
        y = marginTop;
      }
      doc.text(line, marginX, y);
      y += 11;
    });

    doc.save(filename);
    return true;
  } catch (err) {
    console.error("[WillSeva] PDF download failed:", err);
    throw err;
  }
}
